import { disableCapturing } from '@/lib/analytics'

declare global {
  interface Window {
    // Defined in application.html.erb whenever this environment could load
    // PostHog (production, real host, signed-out visitor). Calling it starts
    // tracking immediately, without a page reload — see the layout's comment.
    __initPostHog?: () => void
  }
}

const COOKIE_NAME = 'cookie_consent'
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365
const RESET_EVENT = 'cookie-consent:reset'

// Cookies written from an HTTP origin (local dev) silently drop the Secure
// attribute — appending it unconditionally would break the whole feature
// outside production, where the app is always HTTPS anyway.
const secureFlag = () => (location.protocol === 'https:' ? '; Secure' : '')

export type CookieConsent = 'accepted' | 'declined'

export function getCookieConsent(): CookieConsent | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`))
  const value = match ? decodeURIComponent(match[1]) : null
  return value === 'accepted' || value === 'declined' ? value : null
}

export function setCookieConsent(value: CookieConsent) {
  document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax${secureFlag()}`
  if (value === 'accepted') window.__initPostHog?.()
}

export function resetCookieConsent() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secureFlag()}`
  disableCapturing()
  window.dispatchEvent(new Event(RESET_EVENT))
}

export function onCookieConsentReset(callback: () => void) {
  window.addEventListener(RESET_EVENT, callback)
  return () => window.removeEventListener(RESET_EVENT, callback)
}
